import { NativeTabs } from 'expo-router/unstable-native-tabs';
import * as React from 'react';
import { Platform, useWindowDimensions, View } from 'react-native';

import { AdminTenantGuard } from '@/components/admin-tenant-guard';
import { AdminSidebar } from '@/components/admin-sidebar';
import { useTenant } from '@/components/tenant-provider';
import { BRAND } from '@sixam/config/brand';
import { useReleaseFeatureFlag } from '@/lib/use-release-feature-flag';

export default function AdminTenantLayout() {
  const { height, width } = useWindowDimensions();
  const { activeTenant } = useTenant();
  const contactManagementEnabled = useReleaseFeatureFlag('contactManagement') === true;
  const broadcastMessagingEnabled = useReleaseFeatureFlag('broadcastMessaging') === true;
  const avatarUrl = activeTenant?.avatar_url;
  const avatarSource = React.useMemo(
    () => (avatarUrl ? { uri: avatarUrl } : undefined),
    [avatarUrl]
  );
  const useSidebarLayout =
    Platform.OS === 'ios' && Platform.isPad && width > height && width >= 900;

  return (
    <AdminTenantGuard>
      <View className={useSidebarLayout ? 'flex-1 flex-row bg-background' : 'flex-1 bg-background'}>
        {useSidebarLayout ? <AdminSidebar /> : null}
        <View className="min-w-0 flex-1">
          <NativeTabs
            tintColor={BRAND.color.orange}
            minimizeBehavior="onScrollDown"
            sidebarAdaptable={false}
            hidden={useSidebarLayout}
          >
            {contactManagementEnabled ? (
              <NativeTabs.Trigger name="contacts">
                <NativeTabs.Trigger.Label>contacts</NativeTabs.Trigger.Label>
                <NativeTabs.Trigger.Icon sf="person.2" md="contacts" />
              </NativeTabs.Trigger>
            ) : null}

            {broadcastMessagingEnabled ? (
              <NativeTabs.Trigger name="broadcasts">
                <NativeTabs.Trigger.Label>broadcasts</NativeTabs.Trigger.Label>
                <NativeTabs.Trigger.Icon sf="megaphone" md="campaign" />
              </NativeTabs.Trigger>
            ) : null}

            <NativeTabs.Trigger name="(profile)">
              <NativeTabs.Trigger.Label>club</NativeTabs.Trigger.Label>
              {avatarSource ? (
                <NativeTabs.Trigger.Icon src={avatarSource} renderingMode="original" />
              ) : (
                <NativeTabs.Trigger.Icon sf="person.2.circle" md="groups" />
              )}
            </NativeTabs.Trigger>
          </NativeTabs>
        </View>
      </View>
    </AdminTenantGuard>
  );
}
